"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorMap = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mithril_component_1 = require("../../components/mithril.component");
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var topological_editor_map_overlay_1 = require("./topological.editor.map.overlay");
exports.CSS = {
    wrapper: 'c-MapWrapper'
};
var Style = (_a = {},
    _a[exports.CSS.wrapper] = {
        height: '100%',
        width: '100%'
    },
    _a);
(0, theme_1.addStyles)(Style);
var TopologicalEditorMap = /** @class */ (function (_super) {
    tslib_1.__extends(TopologicalEditorMap, _super);
    function TopologicalEditorMap(options) {
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.name = 'TopologicalEditorMap';
        services_1.Services.Map.isReadyPromise
            .then(function () {
            _this.map = services_1.Services.Map.map;
            _this.map.setMapTypeId('satellite');
            _this.map.set('streetViewControl', true);
            _this.overlay = new topological_editor_map_overlay_1.TopologicalEditorMapOverlay({
                map: _this.map,
                onCollectionClick: function (id) { return _this.options.onTagClick(id); },
                onVectorClick: function (collectionId, vectorId) {
                    _this.options.onVectorClick(collectionId, vectorId);
                },
                onVectorDragStart: _this.options.onVectorDragStart
            });
        });
        return _this;
    }
    TopologicalEditorMap.prototype.onCreate = function (vnode) {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
        this.map = services_1.Services.Map.attach(vnode.dom);
    };
    TopologicalEditorMap.prototype.onRemove = function () {
        this.overlay.hide();
        this.overlay.onRemove();
    };
    Object.defineProperty(TopologicalEditorMap.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', {
                className: exports.CSS.wrapper
            });
        },
        enumerable: false,
        configurable: true
    });
    return TopologicalEditorMap;
}(mithril_component_1.IMithrilComponent));
exports.TopologicalEditorMap = TopologicalEditorMap;
//# sourceMappingURL=topological.editor.map.js.map